import { connect } from "react-redux";
import PublicationPage from "./PublicationPage";
import { uploadFile } from "../../../../../redux/actions/attachment_actions"
import { saveWorkInstruction } from "../../../../../redux/actions/wi_actions"

const mapStateToProps = (state) => {
    return ({
        currentUser: state.session.user,
    });
}

const mapDispatchToProps = (dispatch) => {
    return({
        uploadFile: (fd) => dispatch(uploadFile(fd,false)),
        updateWorkInstruction: updatedWorkInstruction => dispatch(saveWorkInstruction(updatedWorkInstruction)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicationPage);